<header class="account-contests-header">
  <h3 class="account-contests-title">{{ 'contests_' | translate }}</h3>
</header>
<main>
  <p class="account-contests-subtitle">{{ 'contests_text' | translate }}</p>
  <div class="account-contests-container">
    <ng-container *ngIf="loading; else realContests">
      <section class="account-contests-section">
        <skeleton-contest [smallVersionOnly]="true"></skeleton-contest>
      </section>
    </ng-container>
    <ng-template #realContests>
      <section *ngFor="let contest of wonContests" class="account-contests-section">
        <contest [smallVersionOnly]="true" [contest]="contest"></contest>
      </section>
    </ng-template>
  </div>
</main>
